// Your personal API key.
// Get it here: https://console.cloud.google.com/google/maps-apis
const API_KEY = 'AIzaSyBG9gy2nA4LYg0V_cBT7p0L3lKOH2YL5TM'
const CALLBACK_NAME = 'gmapsCallback'

let initialized = !!window.google
let resolveInitPromise
let rejectInitPromise
// This promise handles the initialization
// status of the google maps script.
const initPromise = new Promise((resolve, reject) => {
  resolveInitPromise = resolve
  rejectInitPromise = reject
});

export default function init() {
  if (initialized) return initPromise

  initialized = true
  window[CALLBACK_NAME] = () => resolveInitPromise(window.google)
  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK_NAME}&libraries=places`
  script.onerror = rejectInitPromise
  document.querySelector('head').appendChild(script)

  return initPromise
}

export const loadedGoogleMapsAPI = new Promise((resolve, reject) => {

  window['GoogleMapsInit'] = resolve

  let GMap = document.createElement('script')

  GMap.async = true
  GMap.defer = true
  GMap.setAttribute('src',
    `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_API_KEY}&callback=GoogleMapsInit&libraries=places`)

  document.body.appendChild(GMap)
})
